/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable no-restricted-syntax */
/* eslint-disable indent */
/* eslint-disable no-trailing-spaces */
/* eslint-disable no-else-return */
/* eslint-disable react/jsx-indent */

import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronDown,
  faChevronRight,
  faDownload,
  faEdit,
} from '@fortawesome/free-solid-svg-icons';
import './FarmerProfileDetailPage.scss';
import Swal from 'sweetalert2';
import {
  downloadFarmerProfile,
  getFarmerProfileByID,
  handleFarmerProfileApproval,
  handleFarmerProfileRejection,
  getSignatureData,
  deleteSignatureById,
  postSignatureDataInAdminSide,
  postSignatureDataInPlantSide,
  storeUserIpAddress,
  updateFarmerProfileDetails,
} from '../../store/modules/newUser/actions';
import {
  selectFarmerData,
  selectIsLoadingApproval,
  selectIsLoadingRejection,
  selectSignatureArray,
  selectIpAddress,
  selectIsLoading,
} from '../../store/modules/newUser/selectors';
import SignaturesModal from '../../components/SignaturesModal';
import DigitalSignatureModal from '../../components/DigitalSingatureModal';
import EditNewUserFarmerCodeModal from '../../components/EditNewUserFarmerCodeModal';

const FarmerProfileDetails = () => {
  const [maskAadhar, setMaskAadhar] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const role = localStorage?.getItem('role');
  const [expandedSections, setExpandedSections] = useState({
    basic: true,
    household: true,
    cattle: true,
    milk: true,
    feed: true,
    assets: true,
    income: true,
    bank: true,
  });
  const [ip, setip] = useState('IP Address Not available');
  const [showSignatureModal, setshowSignatureModal] = useState(false);
  const [showDigitalSignatureModal, setshowDigitalSignatureModal] = useState(false);
  const [showFarmerCodeModal, setShowFarmerCodeModal] = useState(false);

  const data = useSelector((state) => selectFarmerData(state));
  const isLoading = useSelector((state) => selectIsLoading(state));
  const isLoadingFinish = useSelector((state) => selectIsLoadingApproval(state));
  const isLoadingReject = useSelector((state) => selectIsLoadingRejection(state));
  const signatureArray = useSelector((state) => selectSignatureArray(state));
  const ipAddress = useSelector((state) => selectIpAddress(state));

  const dispatch = useDispatch();
  const { id } = useParams();

  const [userType, setUserType] = useState('admin');

  useEffect(() => {
    if (!id) return;
    let type = '';
    if (role === 'plant-admin' || role === 'plant_ic') {
      type = 'plant';
    } else {
      type = 'admin';
    }
    setUserType(type);
    dispatch(getFarmerProfileByID(id, type));
  }, [dispatch, id, role]);

  const toggleSection = (section) => {
    setExpandedSections((prev) => ({ ...prev, [section]: !prev[section] }));
  };

  const handleImageClick = (imageUrl, type) => {
    setSelectedImage({ url: imageUrl, type });
    setShowImageModal(true);
  };

  const handlePdfDownload = (val) => {
    fetch(val, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      },
    })
      .then((response) => {
        response.arrayBuffer().then((buffer) => {
          const url = window.URL.createObjectURL(new Blob([buffer]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${data?.farmerName}-FARMER_ENROLLMENT_FORM.pdf`);
          document.body.appendChild(link);
          link.click();
        });
      })
      .catch((err) => {
        toast.error(err);
      });
  };

  const handleOnPdfPressed = () => {
    dispatch(downloadFarmerProfile(id, handlePdfDownload));
  };

  const getFacilityLabel = () => {
    const farmerType = data?.farmerType;
    if (farmerType === 'HPC') return 'HPC Name';
    if (farmerType === 'MCC') return 'MCC Name';
    if (farmerType === 'DF') return 'Dairy Farmer Name';
    return 'Facility Name';
  };

  const getFacilityCodeLabel = () => {
    const farmerType = data?.farmerType;
    if (farmerType === 'HPC') return 'HPC Code';
    if (farmerType === 'MCC') return 'MCC Code';
    if (farmerType === 'DF') return 'Dairy Farmer Code';
    return 'Facility Code';
  };

  const aadharNumberMasked = data?.aadharNumber?.replace(/\d(?=\d{4})/g, '*');

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return 'N/A';
    return date.toLocaleDateString('en-GB');
  };

  const renderDetailRow = (label, value) => (
    <div className="detail-row">
      <div className="detail-label">
        {label}
        :
      </div>
      <div className="detail-value">
        {value ?? 'N/A'}
      </div>
    </div>
  );

  // Calculate total cattle and milk production from cattleData
  const calculateCattleTotals = () => {
    const cattleData = data?.cattleData || {};
    let totalCattle = 0;
    let totalMilk = 0;

    Object.values(cattleData).forEach((categoryBreeds) => {
      if (Array.isArray(categoryBreeds)) {
        categoryBreeds.forEach((breed) => {
          totalCattle += breed.total || 0;
          totalMilk += breed.milkLPD || 0;
        });
      }
    });

    return { totalCattle, totalMilk };
  };

  const { totalCattle, totalMilk } = calculateCattleTotals();

  useEffect(() => {
    dispatch(storeUserIpAddress());
  }, [dispatch]);

  useEffect(() => {
    ipAddress?.then((res) => {
      setip(res ? res?.ip : 'IP Not fetched');
    });
  }, [ipAddress]);

  const handleOnSignatureArrayDataCalled = () => {
    setshowSignatureModal(!showSignatureModal);
    const values = {
      type: userType,
    };
    dispatch(getSignatureData(values));
  };

  const handleOnDigitalSignatureModalCalled = () => {
    setshowDigitalSignatureModal(!showDigitalSignatureModal);
  };

  // const handleOnValueSelectedFromSignatureModal = (val) => {
  //   if (role === 'ea_pi') {
  //     if (data?.vendorCode && data?.farmerCode) {
  //       // Proceed if codes exist
  //       const approvedData = {
  //         id,
  //         status: 'approved',
  //         ipAddress: ip,
  //         signatureUrl: val?.signatureUrl,
  //       };
  //       dispatch(handleFarmerProfileApproval(approvedData, userType));
  //     } else {
  //       // Show missing fields alert if codes are missing
  //       Swal.fire({
  //         icon: 'warning',
  //         title: 'Missing Fields!',
  //         text: 'For approval, the Farmer Code and Vendor Code should not be left blank.',
  //         toast: true,
  //         showConfirmButton: true,
  //         showCancelButton: true,
  //         confirmButtonText: 'Add them',
  //         confirmButtonColor: '#229945',
  //         cancelButtonColor: '#f26868',
  //         cancelButtonText: 'Cancel',
  //       }).then((response) => {
  //         if (response.isConfirmed) {
  //           setShowFarmerCodeModal(!showFarmerCodeModal);
  //         }
  //       });
  //     }
  //   } else {
  //     // Proceed normally for other roles
  //     const approvedData = {
  //       id,
  //       status: 'approved',
  //       ipAddress: ip,
  //       signatureUrl: val?.signatureUrl,
  //     };
  //     dispatch(handleFarmerProfileApproval(approvedData, userType));
  //   }
  // };

  const handleOnValueSelectedFromSignatureModal = (val) => {
    const approvedData = {
      id,
      status: 'approved',
      ipAddress: ip,
      signatureUrl: val?.signatureUrl,
    };
    dispatch(handleFarmerProfileApproval(approvedData, userType));
  };

  const handleOnDeleteSignatureCalled = (value) => {
    const valuesToBepassed = {
      id: value?.id,
      type: userType,
    };
    dispatch(deleteSignatureById(valuesToBepassed));
  };

  const handleOnSignatureFetchedFromCanvasModal = (val) => {
    const values = {
      signature: val,
    };
    if (val !== null) {
      if (userType === 'plant') {
        dispatch(postSignatureDataInPlantSide(values));
      } else {
        dispatch(postSignatureDataInAdminSide(values));
      }
      handleOnSignatureArrayDataCalled();
    }
  };

  const toggleFarmerCodeModal = () => {
    setShowFarmerCodeModal(!showFarmerCodeModal);
  };

  const updateFarmerCodeVendorCode = (values) => {
    const updateData = {
      farmerCode: values?.farmerCode ? values?.farmerCode : null,
      vendorCode: values?.vendorCode ? values?.vendorCode : null,
      id,
    };
    dispatch(updateFarmerProfileDetails(updateData));
  };

  const reject = () => {
    Swal.fire({
      title: 'Enter your reason for rejection',
      input: 'textarea',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Proceed',
    }).then((result) => {
      if (result.isConfirmed) {
        if (result.value) {
          const rejectData = {};
          rejectData.id = id;
          rejectData.status = 'rejected';
          rejectData.comment = result.value;
          dispatch(handleFarmerProfileRejection(rejectData, userType));
        }
        Swal.fire({
          title: 'Update!',
          text: 'You have successfully rejected',
          icon: 'success',
          timer: 2000,
        });
      }
    });
  };

  const approve = () => {
    handleOnSignatureArrayDataCalled();
  };

  const renderApprovalSignature = (signatureUrl, label) => (
    signatureUrl ? (
      <div className="approval-signature">
        <span className="approval-signature__label">{label}</span>
        <img
          src={signatureUrl}
          alt={label}
          className="approval-signature__image"
        />
      </div>
    ) : null
  );

  return (
    <div className="farmer-profile-container">
      {!isLoading && data ? (
        <>
          {(role === 'ea_pi' && data?.createdByEAPandI === 'pending')
            || (role === 'regional_fa' && data.verifiedByRIFandA === 'pending')
            || (role === 'regional_pi' && data.approvedByRIPandI === 'pending')
            || ((role === 'plant-admin' || role === 'plant_ic') && data.preparedByPlantIC === 'pending') ? (
            <div className="row center" style={{ marginBottom: '20px' }}>
              <div className="col-12 col-md-12">
                <div className="buttons">
                  <button
                    type="button"
                    className="button danger"
                    onClick={reject}
                  >
                    Reject
                  </button>
                  <button
                    type="button"
                    className="button primary"
                    onClick={approve}
                  >
                    Approve
                  </button>
                </div>
              </div>
            </div>
          ) : null}

          <div className="row center">
            <div className="col-12 col-md-12 col-lg-12">
              <div className="status-card">
                <div className="left">
                  <div>
                    1. Approved By Plant IC:
                    {' '}
                    {data.preparedByPlantIC}
                  </div>
                  {renderApprovalSignature(data.planticSign, 'Plant IC Signature')}
                </div>
                <div className="right">
                  <div>
                    2. Status at RH P&I:
                    {' '}
                    {data.approvedByRIPandI}
                  </div>
                  {renderApprovalSignature(data.rhpiSign, 'RH P&I Signature')}
                </div>
              </div>
            </div>
          </div>
        </>
      ) : null}
      <div className="section-header">
        <h2>Farmer Profile Details</h2>
        {((role === 'regional_pi' && data?.approvedByRIPandI === 'approved') || (role === 'regional_fa' && data?.verifiedByRIFandA === 'approved') || (role === 'ea_pi' && data?.createdByEAPandI === 'approved') || (role === 'admin')) && (
          <div className="buttons">
            <button
              type="button"
              className="button primary"
              onClick={handleOnPdfPressed}
            >
              <FontAwesomeIcon icon={faDownload} />
              Download
            </button>
          </div>
        )}
      </div>
      <div className="info-card">
        <div className="info-item">
          <span className="info-label">Farmer Type:</span>
          <span className="info-value">
            {data?.farmerType ?? 'N/A'}
          </span>
        </div>
        <div className="info-item">
          <span className="info-label">Farmer Code:</span>
          <span className="info-value">
            {data?.farmerCode || 'N/A'}
            {(role === 'ea_pi' && data?.createdByEAPandI === 'pending') && (
              <FontAwesomeIcon
                icon={faEdit}
                className="edit-icon"
                style={{ marginLeft: '10px', cursor: 'pointer', color: '#175fad' }}
                onClick={toggleFarmerCodeModal}
                title="Edit Codes"
              />
            )}
          </span>
        </div>
        <div className="info-item">
          <span className="info-label">Vendor Code:</span>
          <span className="info-value">
            {data?.vendorCode || 'N/A'}
            {(role === 'ea_pi' && data?.createdByEAPandI === 'pending') && (
              <FontAwesomeIcon
                icon={faEdit}
                className="edit-icon"
                style={{ marginLeft: '10px', cursor: 'pointer', color: '#175fad' }}
                onClick={toggleFarmerCodeModal}
                title="Edit Codes"
              />
            )}
          </span>
        </div>
        <div className="info-item">
          <span className="info-label">Plant Name:</span>
          <span className="info-value">
            {data?.plantName ?? 'N/A'}
          </span>
        </div>
        <div className="info-item">
          <span className="info-label">
            {getFacilityLabel()}
            :
          </span>
          <span className="info-value">
            {data?.facilityName ?? 'N/A'}
          </span>
        </div>
        <div className="info-item">
          <span className="info-label">
            {getFacilityCodeLabel()}
            :
          </span>
          <span className="info-value">
            {data?.facilityCode ?? 'N/A'}
          </span>
        </div>
        <div className="info-item">
          <span className="info-label">Plant Code:</span>
          <span className="info-value">
            {data?.plantCode ?? 'N/A'}
          </span>
        </div>
        <div className="info-item">
          <span className="info-label">Region:</span>
          <span className="info-value">
            {data?.regionName ?? 'N/A'}
          </span>
        </div>
      </div>

      {/* Basic Information */}
      <div className="section-card">
        <div className="section-header" onClick={() => toggleSection('basic')} role="button" tabIndex={0}>
          <div className="section-header-left">
            <FontAwesomeIcon icon={expandedSections.basic ? faChevronDown : faChevronRight} className="chevron-icon" />
            <h3>1. Basic Information</h3>
          </div>
        </div>

        {expandedSections.basic && (
          <div className="section-content">
            <div className="content-grid">
              <div className="grid-column">
                {renderDetailRow('Farmer Name', data?.farmerName)}
                {renderDetailRow('Father/Husband Name', data?.husbandFatherName)}
                {renderDetailRow('Gender', data?.gender)}
                {renderDetailRow('Date of Birth', formatDate(data?.dob))}
                {renderDetailRow('Mobile Number', data?.phone)}
                {renderDetailRow('Email', data?.email)}
                {renderDetailRow('Education', data?.educationQualification?.replace('_', ' ')?.toUpperCase())}
              </div>
              <div className="grid-column">
                {renderDetailRow('House No./D.No', data?.hNoDno)}
                {renderDetailRow('Village', data?.village)}
                {renderDetailRow('Mandal', data?.mandal)}
                {renderDetailRow('District', data?.district)}
                {renderDetailRow('State', data?.state)}
                {renderDetailRow('Pin Code', data?.pinCode)}
                {renderDetailRow('PAN Card', data?.panCardNumber)}
                {renderDetailRow('Ration Card', data?.rationCardNumber)}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Household & Documents */}
      <div className="section-card">
        <div className="section-header" onClick={() => toggleSection('household')} role="button" tabIndex={0}>
          <div className="section-header-left">
            <FontAwesomeIcon icon={expandedSections.household ? faChevronDown : faChevronRight} className="chevron-icon" />
            <h3>2. Household & Documents</h3>
          </div>
        </div>

        {expandedSections.household && (
          <div className="section-content">
            <div className="content-grid">
              <div className="grid-column">
                <h4 className="subsection-title">Documents</h4>
                <div className="detail-row">
                  <div className="detail-label">Aadhar Number:</div>
                  <div
                    className="detail-value clickable"
                    onClick={() => setMaskAadhar((prev) => !prev)}
                    title="Click to toggle mask"
                    role="button"
                    tabIndex={0}
                  >
                    {maskAadhar ? data?.aadharNumber ?? 'N/A' : aadharNumberMasked ?? 'N/A'}
                  </div>
                </div>

                {renderDetailRow('Nominee Name', data?.nomineeName)}
                {renderDetailRow('Nominee Identity', data?.nomineeIdentity)}

                <div className="images-row">
                  {data?.aadharCardUrl && (
                    <div className="image-container">
                      <h4>Aadhar Card</h4>
                      <img src={data.aadharCardUrl} alt="Aadhar Card" onClick={() => handleImageClick(data.aadharCardUrl, 'Aadhar Card')} />
                    </div>
                  )}
                </div>
              </div>

              <div className="grid-column">
                <h4 className="subsection-title">Household Members</h4>
                {data?.householdMembers && data.householdMembers.length > 0 ? (
                  data.householdMembers.map((member) => (
                    <div key={member?.id} className="member-card">
                      <div className="member-name">
                        {member?.name ?? 'N/A'}
                      </div>
                      <div className="member-details">
                        {`Gender: ${member?.sex ?? 'N/A'} • Age: ${member?.age ?? 'N/A'} • Relation: ${member?.relation ?? 'N/A'}`}
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="no-data">No household members added</div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Cattle Information - NEW JSONB FORMAT */}
      <div className="section-card">
        <div className="section-header" onClick={() => toggleSection('cattle')} role="button" tabIndex={0}>
          <div className="section-header-left">
            <FontAwesomeIcon icon={expandedSections.cattle ? faChevronDown : faChevronRight} className="chevron-icon" />
            <h3>3. Cattle Information</h3>
          </div>
        </div>

        {expandedSections.cattle && (
          <div className="section-content">
            {data?.cattleData && Object.keys(data.cattleData).length > 0 ? (
              <>
                <div className="cattle-summary">
                  <div className="summary-item">
                    <span className="summary-label">Total Cattle:</span>
                    <span className="summary-value">{totalCattle}</span>
                  </div>
                  <div className="summary-item">
                    <span className="summary-label">Total Milk Production:</span>
                    <span className="summary-value">
                      {totalMilk}
                      LPD
                    </span>
                  </div>
                </div>

                {Object.entries(data.cattleData).map(([category, breeds]) => (
                  <div key={category} className="cattle-category">
                    <h4 className="cattle-category-title">{category}</h4>
                    <div className="breeds-grid">
                      {Array.isArray(breeds) && breeds.map((breed) => (
                        <div key={breed.subCategoryId} className="breed-card">
                          <div className="breed-header">
                            <span className="breed-name">{breed.label}</span>
                          </div>
                          <div className="breed-details-grid">
                            <div className="breed-detail">
                              <span className="detail-label">Total:</span>
                              <span className="detail-value">{breed.total || 0}</span>
                            </div>
                            <div className="breed-detail">
                              <span className="detail-label">In Milk:</span>
                              <span className="detail-value">{breed.inMilk || 0}</span>
                            </div>
                            <div className="breed-detail">
                              <span className="detail-label">Dry:</span>
                              <span className="detail-value">{breed.dry || 0}</span>
                            </div>
                            <div className="breed-detail">
                              <span className="detail-label">Heifers:</span>
                              <span className="detail-value">{breed.heifers || 0}</span>
                            </div>
                            <div className="breed-detail">
                              <span className="detail-label">Calves:</span>
                              <span className="detail-value">{breed.calves || 0}</span>
                            </div>
                            <div className="breed-detail">
                              <span className="detail-label">Milk (LPD):</span>
                              <span className="detail-value">{breed.milkLPD || 0}</span>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <div className="no-data">No cattle information added</div>
            )}
          </div>
        )}
      </div>

      {/* Milk Selling Information */}
      <div className="section-card">
        <div className="section-header" onClick={() => toggleSection('milk')} role="button" tabIndex={0}>
          <div className="section-header-left">
            <FontAwesomeIcon icon={expandedSections.milk ? faChevronDown : faChevronRight} className="chevron-icon" />
            <h3>4. Milk Selling Information</h3>
          </div>
        </div>

        {expandedSections.milk && (
          <div className="section-content">
            <h4 className="subsection-title">Milk Quality & Consumption</h4>
            <div className="content-grid-three">
              <div className="grid-column-compact">
                {renderDetailRow('Milk SNF', data?.milkSNF)}
                {renderDetailRow('Milk FAT', data?.milkFAT)}
              </div>
              <div className="grid-column-compact">
                {renderDetailRow('Household Consumption (LPD)', data?.householdConsumptionLPD)}
              </div>
              <div className="grid-column-compact">
                {renderDetailRow('Marketable Milk (LPD)', data?.marketableMilkLPD)}
              </div>
            </div>

            <div className="subsections-row">
              <div className="subsection-half">
                <h4 className="subsection-title">Milk Selling Points</h4>
                {data?.milkSellingPoints && data.milkSellingPoints.length > 0 ? (
                  <div className="compact-cards-grid">
                    {data.milkSellingPoints.map((point) => (
                      <div key={point?.id} className="member-card">
                        <div className="member-name">
                          {point?.typeLabel ?? 'N/A'}
                        </div>
                        <div className="member-details">
                          {`Morning: ${point?.morningLPD ?? 'N/A'} L • Evening: ${point?.eveningLPD ?? 'N/A'} L`}
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="no-data">No milk selling points added</div>
                )}
              </div>

              <div className="subsection-half">
                <h4 className="subsection-title">Milk Products Purchase</h4>
                {data?.milkProductsPurchase && data.milkProductsPurchase.length > 0 ? (
                  <div className="compact-cards-grid">
                    {data.milkProductsPurchase.map((product) => (
                      <div key={product?.id} className="member-card">
                        <div className="member-name">
                          {product?.productLabel ?? 'N/A'}
                        </div>
                        <div className="member-details">
                          {`Source: ${product?.sourceLabel ?? 'N/A'} • Qty: ${product?.quantityPerMonth ?? 'N/A'}/month`}
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="no-data">No milk products purchase data</div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Feed & Fodder and Assets side by side */}
      <div className="sections-row">
        {/* Feed & Fodder Information */}
        <div className="section-card section-card-half">
          <div className="section-header" onClick={() => toggleSection('feed')} role="button" tabIndex={0}>
            <div className="section-header-left">
              <FontAwesomeIcon icon={expandedSections.feed ? faChevronDown : faChevronRight} className="chevron-icon" />
              <h3>5. Feed & Fodder</h3>
            </div>
          </div>

          {expandedSections.feed && (
            <div className="section-content">
              {data?.feedFodderDetails && data.feedFodderDetails.length > 0 ? (
                data.feedFodderDetails.map((feed) => (
                  <div key={feed?.id} className="member-card">
                    <div className="member-name">
                      {feed?.typeLabel ?? 'N/A'}
                    </div>
                    <div className="member-details">
                      {`Source: ${feed?.sourceLabel ?? 'N/A'}${feed?.costPerUnit ? ` • Cost: ₹${feed.costPerUnit}` : ''}`}
                    </div>
                  </div>
                ))
              ) : (
                <div className="no-data">No feed & fodder details added</div>
              )}
            </div>
          )}
        </div>

        {/* Assets & Infrastructure */}
        <div className="section-card section-card-half">
          <div className="section-header" onClick={() => toggleSection('assets')} role="button" tabIndex={0}>
            <div className="section-header-left">
              <FontAwesomeIcon icon={expandedSections.assets ? faChevronDown : faChevronRight} className="chevron-icon" />
              <h3>6. Assets & Infrastructure</h3>
            </div>
          </div>

          {expandedSections.assets && (
            <div className="section-content">
              {data?.assetsInfrastructure && data.assetsInfrastructure.length > 0 ? (
                data.assetsInfrastructure.map((asset) => (
                  <div key={asset?.id} className="member-card">
                    <div className="member-name">
                      {asset?.assetLabel ?? 'N/A'}
                    </div>
                    <div className="member-details">
                      {`${asset?.availabilityLabel ?? 'N/A'} • ${asset?.ownershipLabel ?? 'N/A'}${asset?.areaQtyType ? ` • ${asset.areaQtyType}` : ''}`}
                    </div>
                  </div>
                ))
              ) : (
                <div className="no-data">No assets & infrastructure added</div>
              )}
            </div>
          )}
        </div>
      </div>

      {/* Income Information */}
      <div className="section-card">
        <div className="section-header" onClick={() => toggleSection('income')} role="button" tabIndex={0}>
          <div className="section-header-left">
            <FontAwesomeIcon icon={expandedSections.income ? faChevronDown : faChevronRight} className="chevron-icon" />
            <h3>7. Income Information</h3>
          </div>
        </div>

        {expandedSections.income && (
          <div className="section-content section-content-compact">
            {renderDetailRow('Source of Credit', data?.sourceOfCredit)}

            <h4 className="subsection-title">Income Sources</h4>
            {data?.sourceOfIncome && data.sourceOfIncome.length > 0 ? (
              <div className="compact-cards-grid">
                {data.sourceOfIncome.map((income) => (
                  <div key={income?.id} className="member-card">
                    <div className="member-name">
                      {income?.sourceLabel ?? 'N/A'}
                    </div>
                    <div className="member-details">
                      {`Percentage: ${income?.percentage ?? 'N/A'}%${income?.remarks ? ` • ${income.remarks}` : ''}`}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="no-data">No income source added</div>
            )}
          </div>
        )}
      </div>

      {/* Bank Details */}
      <div className="section-card">
        <div className="section-header" onClick={() => toggleSection('bank')} role="button" tabIndex={0}>
          <div className="section-header-left">
            <FontAwesomeIcon icon={expandedSections.bank ? faChevronDown : faChevronRight} className="chevron-icon" />
            <h3>8. Bank Details</h3>
          </div>
        </div>

        {expandedSections.bank && (
          <div className="section-content">
            <div className="content-grid">
              <div className="grid-column">
                <h4 className="subsection-title">Account Information</h4>
                {renderDetailRow('Name as per Passbook', data?.nameAsPerPassbook)}
                {renderDetailRow('Bank Name', data?.bankName)}
                {renderDetailRow('Branch Name', data?.branchName)}
                {renderDetailRow('Branch Code', data?.branchCode)}
                {renderDetailRow('Account Number', data?.accountNumber)}
                {renderDetailRow('IFSC Code', data?.ifscCode)}
                {renderDetailRow('Account Verified', data?.isBankAccountVerified ? 'Yes' : 'No')}
              </div>
              <div className="grid-column">
                <h4 className="subsection-title">Bank Passbook</h4>
                {data?.bankPassbookUrl ? (
                  <div className="image-container">
                    <img src={data.bankPassbookUrl} alt="Bank Passbook" onClick={() => handleImageClick(data.bankPassbookUrl, 'Bank Passbook')} />
                  </div>
                ) : (
                  <div className="no-data">No bank passbook uploaded</div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>

      {showImageModal && selectedImage && (
        <div className="modal-overlay" onClick={() => setShowImageModal(false)} role="dialog" aria-modal="true">
          <div role="none" className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>
                {selectedImage.type}
              </h3>
              <button type="button" className="close-btn" onClick={() => setShowImageModal(false)} aria-label="Close modal">
                ×
              </button>
            </div>
            <div className="modal-body">
              <img src={selectedImage.url} alt={selectedImage.type} />
            </div>
          </div>
        </div>
      )}
      {showDigitalSignatureModal && (
        <DigitalSignatureModal
          show={showDigitalSignatureModal}
          toggle={handleOnDigitalSignatureModalCalled}
          onSubmit={handleOnSignatureFetchedFromCanvasModal}
        />
      )}
      {showSignatureModal && (
        <SignaturesModal
          signatures={signatureArray}
          show={showSignatureModal}
          isLoading={isLoading}
          onSubmit={handleOnValueSelectedFromSignatureModal}
          toggle={handleOnSignatureArrayDataCalled}
          onDelete={handleOnDeleteSignatureCalled}
          showSignatureCanvas={handleOnDigitalSignatureModalCalled}
        />
      )}
      {showFarmerCodeModal && (
        <EditNewUserFarmerCodeModal
          show={showFarmerCodeModal}
          toggle={toggleFarmerCodeModal}
          onSubmit={updateFarmerCodeVendorCode}
          values={{ farmerCode: data?.farmerCode, vendorCode: data?.vendorCode }}
        />
      )}
    </div>
  );
};

export default FarmerProfileDetails;
